import { cva } from 'class-variance-authority'

// Per-type background lives in TransactionCard's VARIANT_CONFIG (index.tsx),
// applied as a plain className - only Unknown differs (bg-yellow-0), so it
// isn't worth a second type-keyed variant map alongside that config.
export const categoryFieldStyles = cva(`
  flex
  items-center
  gap-2
  w-full
  rounded-lg
  border
  border-neutral-200
  px-4
  py-2
  shadow-sm
  text-left
  disabled:cursor-default
`)
